module.exports = __webpack_public_path__ + "img/footer_logo_outflink.acac17b8.png";